import React from "react";
import { Box } from "@mui/material";

import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

function DefaultContent({ segment, onFormFieldChange }) {
    const canUpdate = segment?.canUpdate ?? false;
    return (
        <Box component="div">
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </Box>
    );
}
export default DefaultContent;
